import { isSystemMessageType } from '@bt-common/schemas/wa/message';

/**
 * WA Web natives that carry no customer-authored content. The listener payload's
 * `type` is the contract type (e2e_notification → `notification`, …), but the
 * native rides in `waType`, and synthetic / older payloads may carry the native
 * in `type` itself — so both are checked.
 */
const NON_CONTENT_NATIVE_TYPES: ReadonlySet<string> = new Set([
    'e2e_notification',
    'protocol',
    'reaction',
    'notification_template',
    'newsletter_notification',
    'broadcast_notification',
    'gp2_notification',
    'biz_content_placeholder',
    'groups_v4_invite',
]);

const isNonContentType = (type: unknown): boolean =>
    typeof type === 'string' && (isSystemMessageType(type) || NON_CONTENT_NATIVE_TYPES.has(type));

/**
 * cancelIfReceived ("cancel if the contact replies"): does this inbound message
 * count as the contact replying? Only a real content message does. A WhatsApp
 * system event in the contact's chat — a security-code change, an encryption
 * notice, a still-undecrypted placeholder, a revoke, a reaction, a missed call —
 * is not a reply, and must not delete the user's scheduled messages.
 */
export const isCancelIfReceivedTrigger = (message: any): boolean => {
    if (!message || message.fromMe === true) return false;
    if (isNonContentType(message.type) || isNonContentType(message.waType)) return false;
    if (message.type === 'unknown') {
        return String(message.body ?? '').trim() !== ''
            || String(message.caption ?? '').trim() !== ''
            || !!message.mediaKey
            || message.hasMedia === true;
    }
    return true;
};
